<template>
    <!-- 编辑添加 -->
    <el-drawer :title="title" :wrapperClosable="false" :visible.sync="isShow" :with-header="true">
        <div class="drawer-form">
            <el-form ref="form" :model="form" label-width="85px">
                <el-form-item label="商户名称">
                    <el-input clearable v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item label="隶属商户">
                    <el-select v-model="form.parent_id" placeholder="隶属商户" class="handle-input mr10" filterable
                        clearable>
                        <el-option v-for="(item, index) in dictionary.getPicker('hotel')" :key="index"
                            :label="item.title" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="可经营分类">
                    <el-select v-model="form.type" filterable clearable class="formSelect" placeholder="请选择经营分类">
                        <el-option v-for="item in dictionary.getPicker('news_type')" :key="item.id" :label="item.title"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="品牌名称">
                    <el-select v-model="form.brand_id" filterable clearable class="formSelect" placeholder="请选择品牌名称">
                        <el-option v-for="item in companyList" :key="item.id" :label="item.title"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="公司名称">
                    <el-input clearable v-model="form.bank_company"></el-input>
                </el-form-item>
                <el-form-item label="银行账户">
                    <el-input v-model="form.bank_account" clearable></el-input>
                </el-form-item>
                <el-form-item label="银行名称">
                    <el-input v-model="form.bank_name" clearable></el-input>
                </el-form-item>
                <el-form-item label="所在城市">
                    <el-select v-model="form.city_id" filterable clearable class="formSelect" placeholder="按城市查找"
                        @change="getAreaList">
                        <el-option v-for="item in cityList" :key="item.id" :label="item.title"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所在区/县">
                    <el-select v-model="form.area_id" filterable clearable class="formSelect" placeholder="按区/县查找">
                        <el-option v-for="item in areaList" :key="item.id" :label="item.shortname"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="详细地址">
                    <el-input v-model="form.address" type="textarea" placeholder="请输入详细地址"></el-input>
                </el-form-item>
                <el-form-item label="联系电话">
                    <el-input v-model="form.mobile" type="number" placeholder="请输入联系电话"></el-input>
                </el-form-item>
                <el-form-item label="是否自营">
                    <el-select v-model="form.is_self" filterable clearable class="formSelect" placeholder="请选择">
                        <el-option v-for="item in selfList" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="上线/下线">
                    <el-select v-model="form.is_valid" filterable clearable class="formSelect" placeholder="请选择">
                        <el-option v-for="item in validList" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input v-model="form.sort" clearable></el-input>
                </el-form-item>
                <input type="hidden" id="0" />
                <el-form-item>
                    <el-button type="primary" @click="save()">提交</el-button>
                    <el-button @click="cancel()">取消</el-button>
                </el-form-item>
            </el-form>
        </div>

    </el-drawer>
</template>

<script>
import dictionary from '@/utils/dictionary.js';
let form = {
    id: "",
    parent_id: "",
    brand_id: "",
    title: "",
    type: "",
    bank_name: "",
    bank_company: "",
    bank_account: "",
    city_id: "",
    area_id: "",
    sort: "",
    mobile: "",
    address: "",
    is_valid: ""
};
export default {
    props: {
        parent: {},
        companyList: {
            type: Array,
            default: function () {
                return [];
            }
        },
        cityList: {
            type: Array,
            default: function () {
                return [];
            }
        },
    },
    data() {
        return {
            isShow: false,
            areaList: [],
            form: Object.assign({}, form),
            validList: [{
                value: 0,
                label: '下线'
            },
            {
                value: 1,
                label: '上线'
            }
            ],
            selfList: [{
                value: 1,
                label: '内部商户'
            },
            {
                value: 2,
                label: '外部商户'
            }, {
                value: 3,
                label: '合作酒店'
            }
            ],
            hotelList: [],
            options: [],
            value: [],
            list: [],
            loading: false,
            title: ""
        };
    },
    beforeMount() {
        this.dictionary = dictionary;
    },
    methods: {

        // 编辑
        show(row) {
            let hotelList = this.dictionary.getPicker('hotel')
            let matched = hotelList.find(ele => ele.parent_id == 0);
            if (row.id) { // 编辑操作
                this.title = '编辑商户信息'
                let url = '/api/dictionary.hotel/read';
                this.form.id = '';
                this.$post(url, {
                    id: row.id
                }).then(res => {
                    this.isShow = true;
                    this.form = res.data.row;
                    this.areaList = res.data.areaList;
                    if (res.data.row.brand_id == 0) {
                        this.form.brand_id = '';
                    }
                    if (res.data.row.parent_id == 0) {
                        this.form.parent_id = '';
                    }
                    if (res.data.row.area_id == 0) {
                        this.form.area_id = '';
                    }
                });
            } else { // 添加操作
                this.isShow = true;
                this.title = '添加商户信息'
                this.form = Object.assign({}, form);
            }
        },
        remoteMethod(query) {
            if (query !== '') {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    this.options = this.list.filter(item => {
                        return item.label.toLowerCase()
                            .indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.options = [];
            }
        },
        // 保存提交
        save() {
            let url = '/api/dictionary.hotel/save';
            let form = this.form;
            if (this.form.city_id !== '' && this.form.area_id !== '' && this.form.title !== '') {
                this.$post(url, form).then(res => {
                    if (res.code == 200) {
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        });
                        this.drawer = false;
                        this.isShow = false;
                        this.parent.getTableData(false)
                    } else {
                        this.$message({
                            message: '请填写正确信息',
                            type: 'warning'
                        });
                    }
                });
            } else {
                this.$message({
                    message: '请填写正确信息',
                    type: 'warning'
                });
            }
        },
        //取消编辑
        cancel() {
            this.isShow = false;
        },
        getAreaList(e) {
            let url = '/api/dictionary.region/getAreaList';
            this.$post(url, {
                id: e
            }).then(res => {
                this.areaList = res.data.areaList;
            });
        },
    }
}
</script>

<style lang="less">
@import url('@/assets/css/drawer.less');
</style>
